import React, { useState } from "react";
import RcTooltip from "rc-tooltip";
import defaultContent from "./elements/noDemoDefaultContent";
import Style from "./styles/style";
import { useTimeoutFn } from "react-use";
import { TooltipProps } from "./types/types";
import sass from "../styled/sass";

const NoDemoLink: React.FC<TooltipProps> = ({
	children,
	placement = "top",
	hidden,
	block,
	toolTipContent = defaultContent,
	className,
	style,
}) => {
	const [isVisible, setIsVisible] = useState(false);
	const { regular, bold } = sass.values.fontFamily;
	const hideTooltip = () => {
		if (isReady() && isVisible) {
			setIsVisible(false);
			cancel();
		} else {
			cancel();
		}
	};
	const [isReady, cancel, reset] = useTimeoutFn(hideTooltip, 2500);

	const display = block ? "block" : "inline-block";
	const fontFamily = block ? regular : bold;

	if (hidden) {
		return null;
	}

	const checkVisible = () => {
		if (!isVisible) {
			return {
				overlayClassName: "rc-tooltip-hidden",
			};
		}
		return;
	};

	return (
		<>
			<Style />
			<RcTooltip
				placement={placement}
				trigger="click"
				overlay={<span>{toolTipContent}</span>}
				{...checkVisible()}
			>
				<span
					data-nodemo={""}
					style={{
						display,
						fontFamily,
						...style,
					}}
					className={className}
					onClick={() => {
						setIsVisible(true);
						reset();
					}}
					onMouseLeave={() => setIsVisible(false)}
				>
					{children}
				</span>
			</RcTooltip>
		</>
	);
};

export default NoDemoLink;
